import {observable, action} from 'mobx'
import {Api} from './api'
import Validator from 'validatorjs'
import {signupRules, freeTrialRules, errorMessages, customNames} from './rules'
import {notification} from 'antd'

export class Signup {
  @observable credentials = new Credentials()
  @observable errors = {}
  @observable billing_plan
  @observable loading = false
  @observable complete = false
  @observable trialRequestComplete = false
  @observable modal = false

  constructor(rootStore) {
    this.rootStore = rootStore
    this.api = new Api()
  }

  @action setBillingPlan(value) {
    this.billing_plan = value
  }

  @action setCredentials(prop, value) {
    this.credentials[prop] = value
  }

  @action reset() {
    this.credentials = new Credentials()
    this.errors = {}
    this.loading = false
  }

  @action resetComplete() {
    this.complete = false
    this.trialRequestComplete = false
  }

  @action openModal() {
    this.modal = true
  }

  @action closeModal() {
    this.modal = false
  }

  @action validateField(name, trial = false) {
    const validation = new Validator(this.credentials, trial ? freeTrialRules : signupRules, errorMessages)
    validation.setAttributeNames(customNames)
    if (validation.fails()) {
      let errors = {}
      errors[name] = validation.errors.first(name)
      this.errors = Object.assign(this.errors, errors)
    }
  }

  @action removeError(name) {
    if (this.errors[name] !== undefined) {
      const {...errors} = this.errors
      delete errors[name]
      this.errors = errors
    }
  }

  @action async submit() {
    const validation = new Validator(this.credentials, signupRules, errorMessages)
    if (validation.passes()) {
      this.loading = true
      try {
        const {billing_plan} = this
        await this.api.submit({billing_plan, ...this.credentials})
        this.complete = true

        const {email, password} = this.credentials
        this.rootStore.auth.login(email, password)

        this.reset()
      } catch(e) {

        const errors = e.field_errors
        if (typeof errors === 'object' && errors !== null) {
          for (let name in errors) {
            if (errors[name]) {
              this.errors[name] = errors[name][0].message
            }
          }
        }

        notification['error']({
          message: 'Failed to sign up',
          description: e.message || 'Unknown error'
        })
      } finally {
        this.loading = false
        this.closeModal()
      }
    }
    if (validation.fails()) {
      this.closeModal()
      const errors = validation.errors.all()
      for (let name in errors) {
        this.errors[name] = errors[name][0]
      }
    }
  }

  @action async freeTrialRequest() {
    const validation = new Validator(this.credentials, freeTrialRules, errorMessages)
    if (validation.passes()) {
      this.loading = true
      try {
        const plan = 4
        await this.api.freeTrialRequest({plan, ...this.credentials})
        this.loading = false
        this.trialRequestComplete = true
        this.reset()
      } catch(e) {

        const errors = e.field_errors
        if (typeof errors === 'object' && errors !== null) {
          for (let name in errors) {
            if (errors[name]) {
              this.errors[name] = errors[name][0].message
            }
          }
        }

        notification['error']({
          message: 'Failed to sign up',
          description: e.message || 'Unknown error'
        })

        this.loading = false
      }
    }
    if (validation.fails()) {
      const errors = validation.errors.all()
      for (let name in errors) {
        this.errors[name] = errors[name][0]
      }
    }
  }

  @action validateCaptcha() {
  }
}

class Credentials {
  @observable email = ''
  @observable business_email = ''
  @observable password = ''
  @observable password_repeat = ''
  @observable first_name = ''
  @observable last_name = ''
  @observable is_professional_trader = 'false'
  @observable instruments2 = []
  @observable company = ''
  @observable number_of_traders = ''
  @observable phone = ''
  @observable country = ''
  @observable state = ''
  @observable recaptcha_response = ''
}
